/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React from 'react';
import { Redirect, Route, Switch } from 'react-router';

import HomePage from './components/pages/HomePage/HomePage';
import ContentManagement from './components/pages/ContentManagement/ContentManagement';
import ImportCCManagementComponent from './components/pages/CCManagement/ImportCCManagementComponent';
import MetadataUpdateStatus from './components/pages/ContentManagement/MetadataUpdateStatus';
import ContentUpdateStatus from './components/pages/ContentManagement/ContentUpdateStatus';
import UploadContentComponent from './components/pages/ContentIngestion/UploadContentComponent';
import UploadMetadataComponent from './components/pages/ContentIngestion/UploadMetadataComponent';
import CuratedContentManagement from './components/pages/CuratedSearch/CuratedContentManagement';
import CCCreationStatusComponent from "./components/pages/CCManagement/CCCreationStatusComponent";
import CCMigrationStatus from "./components/pages/CCManagement/CCMigrationStatus";
import DeleteCCManagement from "./components/pages/CCManagement/DeleteCCManagement";
import ViewBatchLogs from "./components/pages/ContentIngestion/ViewBatchLogs";
import BatchDetails from "./components/pages/ContentIngestion/BatchDetails";
import PriceUpdateStatus from "./components/pages/ContentManagement/PriceUpdateStatus";
import PriceCalculation from "./components/pages/ContentManagement/PriceCalculation";

import CCDeletionStatus from "./components/pages/CCManagement/CCDeletionStatus";

const Routes = () => (<Switch>
    <Redirect exact from="/" to="/content-upload" />
    <Route path="/view-logs" component={ViewBatchLogs}/>
    <Route path="/batch-details/:id" component={BatchDetails}/>
    <Route path="/content-management" component={ContentManagement}/>
    <Route path="/cc-management-upload" component={ImportCCManagementComponent} />
    <Route path="/content-upload" component={UploadContentComponent} />
    <Route path="/metadata-upload" component={UploadMetadataComponent} />
    <Route path="/cc-management-status" component={CCCreationStatusComponent} />
    <Route path="/curated-content-management" component={CuratedContentManagement}/>
    <Route path="/cc-migration-status" component={CCMigrationStatus}/>
    <Route path="/content-update-status" component={ContentUpdateStatus}/>
    <Route path="/metadata-update-status" component={MetadataUpdateStatus}/>
    <Route path="/cc-management-delete" component={DeleteCCManagement}/>
    <Route path="/price-update-status" component={PriceUpdateStatus}/>
    <Route path="/pricing-calculation" component={PriceCalculation}/>
    <Route path="/cc-deletion-status" component={CCDeletionStatus}/>

</Switch>);

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js